/**
 * @file   src\contextApi\wantAdListContext.js
 * @brief  This file is responsible for want ad list context api
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import {useContext, createContext } from "react";


export const listContext = createContext();

function wantAdListContext() {
    const context = useContext(listContext);
    return context;
}
export default wantAdListContext